export default __webpack_public_path__ + "static/media/4.677ad264.png";